// Which recorded attempt a set of TODAY'S ramp is.
//
// A set is identified by its weight within one session's ramp, so the ramp
// matches an attempt by lift and weight. It used to match across ALL history:
// a lifter repeating last week's 100 kg warm-up got no attempt recorded today
// on Next set, and Film attached today's clip to last week's set. So the
// lookup is scoped to attempts made since this ramp session began. Going back
// and doing a set again today still finds today's attempt, and never records
// it twice.

/** Midnight at the start of `t`'s local calendar day, in ms. */
export function startOfDay(t = Date.now()) {
  const d = new Date(t);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
}

/**
 * The attempt this set already has in this session: same lift, same weight,
 * performed at or after `since` (ms). The latest one if somehow there are two.
 * Null when there is none, including when `performedAt` is missing or unreadable.
 */
export function sessionAttempt(attempts, { lift, weight, since }) {
  let best = null;
  let bestAt = -Infinity;
  for (const a of attempts || []) {
    if (String(a.lift) !== String(lift) || Number(a.weight) !== Number(weight)) continue;
    const at = Date.parse(a.performedAt);
    if (!Number.isFinite(at) || at < since) continue;
    if (at >= bestAt) { best = a; bestAt = at; }
  }
  return best;
}
